export class CdcResource {
  udb_code: string;
  area_code: string;
  cdc_code: string;
}